'use client';

import Image from 'next/image';

import { Price, PriceLevel, Text, TextMarkup, TypographyBold, View } from '@bytel/trilogy-react-ts';

import { JOURNEYS, PlanType } from '@app-types/product';

import { calculFinalPrice } from '@helpers/utils';

import { useHome } from '@landing/hooks';

import { IconContainer } from './icon-container';

export function BAndyouPrice({
    bboxPrice,
    show5GPicto,
    firstPlan,
}: Readonly<{
    bboxPrice?: number;
    show5GPicto: boolean;
    firstPlan?: PlanType;
}>) {
    const { selectedPlan, selectedNetwork, otisConfigurator, temporarilySelectedPlan, selectedFaiProduct } = useHome();

    const isMobileFirst = otisConfigurator.value === JOURNEYS.BYOU;

    const price =
        bboxPrice ??
        calculFinalPrice(
            selectedNetwork,
            isMobileFirst ? (selectedPlan ?? firstPlan) : temporarilySelectedPlan,
            selectedFaiProduct,
        );

    return (
        <View className='plan-header is-otis is-4'>
            <Image
                src='https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/nbg.webp'
                priority
                unoptimized
                fill
                alt=''
                style={{
                    objectFit: 'cover',
                    zIndex: 0,
                }}
            />

            <View className='z-1'>
                <View className='has-text-centered'>
                    <Price amount={price} showCents period='mois' level={PriceLevel.LEVEL2} />
                    <IconContainer show5GPicto={show5GPicto} baseProduct={firstPlan} />
                </View>
                <View className='has-text-centered'>
                    <Text markup={TextMarkup.SPAN} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                        sans engagement
                    </Text>
                </View>
            </View>
        </View>
    );
}
